import { ChainId } from '@ui/types/chain';
import {
  Address,
  erc20Abi,
  getContract,
  PublicClient,
  WalletClient,
} from 'viem';

import GenesisAirdrop from '../abis/GenesisAirdrop';
import { getContractAddress } from '../constants';

export const getGenesisAirdrop = ({
  publicClient,
  walletClient,
  chainId,
}: {
  publicClient: PublicClient;
  walletClient?: WalletClient;
  chainId: ChainId;
}) => {
  const address = getContractAddress('GenesisAirdrop', chainId);
  if (!address) throw new Error('Contract address not found');
  
return getContract({
    abi: GenesisAirdrop,
    address,
    client: {
      public: publicClient,
      wallet: walletClient,
    },
  });
};
